import React, { useCallback, useState, memo } from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import { FormattedMessage, useIntl } from "react-intl";
import cx from "classnames";
import { useDispatch } from "react-redux";
import Link from "../../../Link/Link";
import messages from "../../../../locale/messages";
import { updateSmsMethod } from "../../../../actions/siteadmin/SmsMethod/updateSmsMethod";
import { demoRestriction } from "../../../../actions/demoRestriction";
import { CommonAdminEditIcon } from "../../../Common/Assets/SVGIcon/CommonSvgIcon";
import s from "./SmsMethodList.css";

const SmsMethodList = ({ smsMethods }) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const [changingId, setChangingId] = useState(null);
  const handleSetActive = useCallback(
    async (item) => {
      if (!item) return;
      if (changingId === item.id) return;
      setChangingId(item.id);
      const data = {
        id: item.id,
        name: item.name,
        accountId: item.accountId,
        securityId: item.securityId,
        phoneNumber: item.phoneNumber,
        phoneDialCode: item.phoneDialCode,
        phoneCountryCode: item.phoneCountryCode,
        status: "true",
        updateStatus: true,
      };
      try {
        const isRestrict = await dispatch(demoRestriction({}));
        if (isRestrict) return;
        await dispatch(updateSmsMethod(data));
        if (smsMethods && typeof smsMethods.refetch === "function") {
          smsMethods.refetch();
        }
      } catch (err) {
        console.log('Error', err.message)
      } finally {
        setChangingId(null);
      }
    },
    [dispatch, smsMethods, changingId]
  );
  const results = smsMethods?.getAllSmsMethod?.results ?? [];
  return (
    <div className={cx("tableOuterContainer", "whiteDropdown")}>
      <Table className="tableContainer">
        <thead>
          <tr>
            <th>
              <FormattedMessage {...messages.id} />
            </th>
            <th>
              <FormattedMessage {...messages.name} />
            </th>
            <th>
              <FormattedMessage {...messages.status} />
            </th>
            <th>
              <FormattedMessage {...messages.action} />
            </th>
          </tr>
        </thead>
        <tbody>
          {results.length === 0 ? (
            <tr>
              <td colSpan="4">—</td>
            </tr>
          ) : (
            results.map((item) => {
              const isActive = item?.status === "true";
              const isChanging = changingId === item?.id;
              return (
                <tr key={item?.id ?? Math.random()}>
                  <td data-label={formatMessage(messages.id)}>{item?.id}</td>
                  <td data-label={formatMessage(messages.name)}>{item?.name}</td>
                  <td data-label={formatMessage(messages.status)}>
                    <div>
                      {isActive ? (
                        <span>{formatMessage(messages.active)}</span>
                      ) : (
                        <button
                          type="button"
                          className="actionLinkText"
                          onClick={() => handleSetActive(item)}
                          disabled={isChanging}
                          aria-disabled={isChanging}
                          aria-busy={isChanging}
                          style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                        >
                          {isChanging
                            ? `${formatMessage(messages.setAsActive)}`
                            : item?.status === "false"
                              ? formatMessage(messages.setAsActive)
                              : formatMessage(messages.active)}
                        </button>
                      )}
                    </div>
                  </td>
                  <td data-label={formatMessage(messages.action)}>
                    <div>
                      {item?.id !== 1 ? (
                        <Link to={`/siteadmin/sms-method/edit/${item.id}`} className={s.noLink}>
                          <CommonAdminEditIcon className={cx(s.editIcon, 'editIconRTL')} />
                          <span className={s.vtrMiddle}>
                            <FormattedMessage {...messages.editAction} />
                          </span>
                        </Link>
                      ) : (
                        " - "
                      )}
                    </div>
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </Table>
    </div>
  );
};
SmsMethodList.propTypes = {
  smsMethods: PropTypes.shape({
    refetch: PropTypes.func,
    getAllSmsMethod: PropTypes.shape({
      results: PropTypes.arrayOf(PropTypes.object),
    }),
  }),
};
export default withStyles(s)(memo(SmsMethodList));
